import { SITE_URL } from "./seo";

// The five JSON-LD blocks from head.php. In the PHP they were emitted on every
// page, including the BreadcrumbList — which is why the treatment breadcrumb
// appeared on the contact page too. Here `siteSchemas` is global and the
// breadcrumb ships only where it is meaningful.

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Chest Surgery India",
  url: `${SITE_URL}/`,
  logo: `${SITE_URL}/assets/img/logotho.png`,
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "+919540210956",
    contactType: "customer service",
    areaServed: "IN",
    availableLanguage: "en",
  },
  sameAs: [
    "https://www.facebook.com/chestsurgeryindia",
    "https://twitter.com/drparveenyadav7",
    "https://www.instagram.com/chestsurgeryindia/",
    "https://www.youtube.com/channel/UCDvfENuMQ0841MXB2iUOmbw",
    `${SITE_URL}/`,
  ],
};

export const personSchema = {
  "@context": "https://schema.org/",
  "@type": "Person",
  name: "Dr. Parveen Yadav",
  url: `${SITE_URL}/`,
  image: `${SITE_URL}/assets/img/drim.webp`,
  sameAs: [
    "https://www.facebook.com/chestsurgeryindia",
    "https://twitter.com/drparveenyadav7",
    "https://www.instagram.com/chestsurgeryindia/",
    "https://www.youtube.com/channel/UCDvfENuMQ0841MXB2iUOmbw",
    `${SITE_URL}/`,
  ],
  jobTitle: "Thoracic and Surgical Oncologist",
  worksFor: {
    "@type": "Organization",
    name: "Chest Surgery India",
  },
};

export const websiteSchema = {
  "@context": "https://schema.org/",
  "@type": "WebSite",
  name: "Chest Surgery India",
  url: `${SITE_URL}/`,
};

export const oncologicSchema = {
  "@context": "https://schema.org",
  "@type": "Physician",
  medicalSpecialty: "https://schema.org/Oncologic",
  name: "Dr. Parveen Yadav",
  image: `${SITE_URL}/assets/img/drim.webp`,
  "@id": `${SITE_URL}/#physician`,
  url: `${SITE_URL}/`,
  telephone: "+919540210956",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Artemis Hospital, Sector 51",
    addressLocality: "Gurgaon",
    addressRegion: "Haryana",
    addressCountry: "IN",
  },

};

/** Emitted on every page. */
export const siteSchemas = [
  organizationSchema,
  personSchema,
  websiteSchema,
  oncologicSchema,
];

/** Escape HTML delimiters so CMS text cannot terminate a JSON-LD script. */
export function serializeJsonLd(schema: object): string {
  return JSON.stringify(schema).replace(/</g, "\\u003c");
}
